<ag-grid-angular
  class="ag-theme-alpine"
  [serverSideInfiniteScroll]="true"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [statusBar]="statusBar"
  [getContextMenuItems]="getContextMenuItems"
  [sideBar]="sideBar"
  [rowSelection]="rowSelection"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [pivotPanelShow]="pivotPanelShow"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [suppressCopyRowsToClipboard]="true"
  [enableRangeSelection]="false"
  [rowModelType]="rowModelType"
  [columnDefs]="columnDefs"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [pinnedTopRowData]="pinnedTopRowData"
  [defaultColDef]="defaultColDef"
  [rowData]="rowData$ | async"
  [animateRows]="true"
  [suppressRowClickSelection]="false"
  [rowClassRules]="rowClassRules"
  [undoRedoCellEditing]="undoRedoCellEditing"
  [undoRedoCellEditingLimit]="undoRedoCellEditingLimit"
  [enableCellChangeFlash]="enableCellChangeFlash"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (cellClicked)="onCellClicked($event)"
  (cellEditingStarted)="cellEditingStarted($event)"
  (cellValueChanged)="cellValueChanged($event)"
  (cellEditingStopped)="cellEditingStopped($event)"
  (cellEditRequest)="cellEditRequest($event)"
  (filterChanged)="filterChanged($event)"
></ag-grid-angular>
